<template>
<div class="notice-edit relative">
  <menu-item label="背景设置">
    <menu-fill :target="model.background" />
    <menu-background-image class="mt-2" :target="model.background" />
  </menu-item>
  <menu-item>
    <menu-switch v-model="model.enabled" label="是否开启公告" />
  </menu-item>
  <menu-item label="文字颜色">
    <menu-fill :target="model.textColor" solid-color />
  </menu-item>
  <menu-item label="内容">
    <el-input v-model="model.content" class="im-textarea" type="textarea" :rows="8" placeholder="请填写公告内容或语言ID"></el-input>
  </menu-item>
</div>
</template>

<script>
import MenuItem from "~/components/menu/menuItem.vue";
import MenuFill from "~/components/menu/menuFill.vue";
import MenuBackgroundImage from "~/components/menu/menuBackgroundImage.vue";
import MenuSwitch from "~/components/menu/menuSwitch.vue";

export default {
  components: {MenuSwitch, MenuBackgroundImage, MenuFill, MenuItem},
  props: {
    model: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
    }
  }
}
</script>

<style lang="less" scoped>
.notice-edit {
  .im-textarea {
    /deep/ .el-textarea__inner {
      background-color: @primary-color-alpha-1;
      border: 1px solid transparent;
      border-radius: 8px;
      color: @text-color;
      padding: 12px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      font-family: inherit;
      line-height: 1.6;
      font-size: 13px;

      &:hover {
        border-color: @border-color-base;
        background-color: @primary-color-alpha-6;
      }

      &:focus {
        border-color: @primary-color;
        background-color: @primary-color-alpha-1;
        box-shadow: 0 0 0 3px rgba(61, 70, 245, 0.1);
      }
      
      &::placeholder {
        color: @text-color-secondary;
      }

      /* 滚动条美化 */
      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }
      &::-webkit-scrollbar-thumb {
        background: @border-color-base;
        border-radius: 3px;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
    }
  }
}
</style>
